import { createSelector } from 'reselect';
import { MonitoringState } from '../types/store';

// Возвращает текущий интервал дат (Monitoring.metricsInterval)
export const monitoringDateSelector = createSelector(
  (state: { Monitoring: MonitoringState }) => state.Monitoring.metricsInterval,
  (metricsInterval) => metricsInterval
);
